export default __webpack_public_path__ + "static/button_header-58e77e36952da37894063564ddca9d7b.png";